import type { QuotationStatus } from "@/features/quotations/types";

export const QT_STATUSES: { value: QuotationStatus; label: string }[] = [
  { value: "draft", label: "Draft" },
  { value: "sent", label: "Sent" },
  { value: "accepted", label: "Accepted" },
  { value: "rejected", label: "Rejected" },
  { value: "expired", label: "Expired" },
  { value: "cancelled", label: "Cancelled" },
  { value: "converted", label: "Converted" },
];

export function labelFor(
  options: { value: string; label: string }[],
  value: string | null | undefined,
) {
  if (!value) return "—";
  return options.find((o) => o.value === value)?.label ?? value;
}

export function statusTone(
  status: QuotationStatus,
): "success" | "warning" | "danger" | "neutral" {
  switch (status) {
    case "accepted":
    case "converted":
      return "success";
    case "sent":
      return "warning";
    case "rejected":
    case "cancelled":
    case "expired":
      return "danger";
    default:
      return "neutral";
  }
}

export function canEditLines(status: QuotationStatus) {
  return status === "draft";
}

export function canEditHeader(status: QuotationStatus) {
  return status === "draft" || status === "sent";
}
